import { render, staticRenderFns } from "./AddOrderMaterialFile.vue?vue&type=template&id=58ae0d40&scoped=true"
import script from "./AddOrderMaterialFile.vue?vue&type=script&lang=js"
export * from "./AddOrderMaterialFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ae0d40",
  null
  
)

export default component.exports